var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39162 0.559697C9.10375 0.451734 8.78125 0.491809 8.5285 0.666947C8.27575 0.842084 8.125 1.13002 8.125 1.4375V16.5966C7.269 15.9105 6.18244 15.5 5 15.5C2.23857 15.5 0 17.7386 0 20.5C0 23.2614 2.23857 25.5 5 25.5C7.57663 25.5 9.698 23.5511 9.97038 21.047C9.98975 20.972 10 20.8935 10 20.8125V9.04031L18.7334 12.3154C19.0213 12.4232 19.3438 12.3832 19.5965 12.208C19.8493 12.0329 20 11.745 20 11.4375V7.35313C20 5.6597 18.9495 4.1439 17.364 3.5493L9.39162 0.559697ZM8.125 20.5C8.125 22.2259 6.72589 23.625 5 23.625C3.27411 23.625 1.875 22.2259 1.875 20.5C1.875 18.7741 3.27411 17.375 5 17.375C6.72589 17.375 8.125 18.7741 8.125 20.5ZM18.125 10.0847L10 7.03781V2.79031L16.7056 5.30491C17.5594 5.62508 18.125 6.44128 18.125 7.35313V10.0847Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.31a626428c904d198c9455ac62cf5657.svg";
export { ForwardRef as ReactComponent };